import React, { memo, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { mainUrl } from '@sunbit-dev/common/helpers/url';
import { LinkButton } from '@sunbit-dev/web-ui-lib';
import { ProgressBar } from '../progressBar/ProgressBar';
import { TopProps } from './models';
import * as styles from './styles';

import logo from '../../assets/sunbit-logo-blue.svg';

const Top = styled(
  ({
    className,
    showCloseButton,
    headerTitleText,
    headerReturnClick,
    currentStep,
    showProgressBar,
    onSupportClick,
  }: TopProps) => {
    const hiddenElementRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
      hiddenElementRef?.current?.focus();
    }, []);

    return (
      <header {...{ className, 'data-testid': 'application-top' }}>
        {/* Hidden element for accessibility */}
        <span {...{ className: 'accessibility-point', ref: hiddenElementRef, tabIndex: 0 }} />

        <section {...{ className: 'top-bar-container' }}>
          {showCloseButton && (
            <LinkButton
              {...{
                'data-testid': 'close-button',
                className: 'close-button',
                id: 'headerReturnActionButton',
                onClick: headerReturnClick,
              }}
            />
          )}
          {onSupportClick && (
            <LinkButton
              {...{
                className: 'contact-support-button',
                id: 'headerContactSupportButton',
                onClick: onSupportClick,
                'data-testid': 'contact-support-button',
              }}
            />
          )}
          <section className="logo-container">
            <a {...{ className: 'logo-wrapper', href: mainUrl, 'data-at': 'sunbit-logo-link', target: '_blank' }}>
              <img src={logo} alt="sunbit logo" />
            </a>
          </section>
          {!!headerTitleText && (
            <div {...{ className: 'header-title', 'data-testid': 'header-title', children: headerTitleText }} />
          )}
        </section>
        {showProgressBar && (
          <ProgressBar
            {...{
              dataTestId: 'progress-bar',
              // currentStep as number since currentStep should always be a number when showProgressBar is true
              step: currentStep as number,
            }}
          />
        )}
      </header>
    );
  }
)`
  ${styles.Top}
`;

Top.defaultProps = {
  showProgressBar: false,
  showCloseButton: true,
};

const MemoTop = memo(Top);

export { MemoTop as Top };
